import { appliesMeta } from '@/utils/functions/applies-meta'
import Users from 'components/users'

export default appliesMeta({
  template: 'chameleon',
  requiresAuth: true
}, [
  {
    path: '/users',
    component: Users.Users,
    name: 'users.index',
    meta: { template: 'chameleon', requiresAuth: true }
  },
  {
    path: '/users/:id',
    component: Users.UsersSingle,
    name: 'users.show',
    props: true,
    meta: {
      template: 'chameleon',
      requiresAuth: true
    },
    children: [
      {
        path: 'overview',
        component: Users.Overview,
        name: 'users.overview',
      },
      {
        path: 'access-permissions',
        name: 'users.single.permissions',
        component: Users.UsersSinglePermissions,
        meta: {
          can: 'read permissions'
        },
      },
      {
        path: 'timesheet',
        component: Users.Timesheet,
        name: 'users.timesheet',
      },
      {
        path: 'scheduled-tasks',
        component: Users.ScheduledTasks,
        name: 'users.scheduled-tasks',
      }
    ]
  },
])
